//import React from "react";
//import React, { useState } from "react";
//import React, { useState } from "react";

// LEAFLET imports (ONLY ONCE — very important)
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  LayersControl,
} from "react-leaflet";
import L from "leaflet";

import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import React, { useState, useEffect } from "react";
//import { MapContainer, TileLayer, Marker, LayersControl } from "react-leaflet";

function SearchField() {
  const map = useMapEvents({});

  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider,
      style: "bar",
      autoComplete: true,
      autoCompleteDelay: 250,
      showMarker: true,
      showPopup: false,
    });

    map.addControl(searchControl);

    return () => map.removeControl(searchControl);
  }, [map]);

  return null;
}

// Fix for default Leaflet icons
const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const baseLayers = {
  Street: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  Satellite: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
  Terrain: "https://{s}.tile.stamen.com/terrain/{z}/{x}/{y}.jpg",
};

async function getAddressFromCoordinates(lat, lng) {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
  );
  const data = await res.json();
  return data.display_name; // full readable address
}

function DraggableMarker({ position, setPosition }) {
  const map = useMapEvents({
    click(e) {
      setPosition(e.latlng); // Move marker when user clicks map
    },
  });

  return (
    <Marker
      draggable
      eventHandlers={{
        dragend: (e) => setPosition(e.target.getLatLng()),
      }}
      position={position}
      icon={markerIcon}
    />
  );
}

export default function Dashboard() {
  const [showNotice, setShowNotice] = useState(true);
  const [showRegmap, setShowRegmap] = useState(false);

  const [signupData, setSignupData] = useState({
    name: "",
    address: "",
    latitude: "",
    longitude: "",
    permit: "yes",
  });

  const [showMap, setShowMap] = useState(false);
  const [mapPosition, setMapPosition] = useState({
    lat: 6.5244,
    lng: 3.3792,
  });

  useEffect(() => {
    async function updateAddress() {
      const address = await getAddressFromCoordinates(
        mapPosition.lat,
        mapPosition.lng
      );

      setSignupData((prev) => ({
        ...prev,
        address: address,
        latitude: mapPosition.lat,
        longitude: mapPosition.lng,
      }));
    }

    updateAddress();
  }, [mapPosition]);

  //CSS STYLING STARTS HERE

  const backdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const formStyle = {
    background: "white",
    padding: 36,
    borderRadius: 12,
    width: 480,
    maxWidth: "90%",
    position: "relative",
    boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: 12,
    right: 12,
    fontSize: 22,
    lineHeight: 1,
    cursor: "pointer",
    border: "none",
    background: "transparent",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    marginBottom: 12,
    borderRadius: 8,
    border: "1px solid #ddd",
    boxSizing: "border-box",
    fontSize: 14,
  };

  const primaryBtn = {
    width: "100%",
    padding: "12px 14px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 15,
  };

  return (
    <div>
      {/* ===== Notification Bar ===== */}
      {showNotice && (
        <div
          style={{
            width: "100%",
            background: "#2563eb",
            color: "white",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontFamily: "Inter, sans-serif",
            position: "relative",
          }}
        >
          {/* Message */}
          <span style={{ fontSize: 15, fontWeight: 500 }}>
            Map your shop location to appear on the dashboard map!
          </span>

          {/* Action + Close */}
          <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
            <button
              onClick={() => {
                setShowRegmap(true);
                //setShowLogin(false);
              }}
              style={{
                background: "white",
                color: "#2563eb",
                padding: "8px 14px",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Map Now
            </button>

            <span
              onClick={() => setShowNotice(false)}
              style={{
                fontSize: 22,
                cursor: "pointer",
                lineHeight: 1,
                fontWeight: 600,
              }}
            >
              ×
            </span>
          </div>
        </div>
      )}
      {/* ===== Dashboard Content ===== */}
      <div style={{ padding: 30 }}>
        <h1>Dashboard</h1>
        <p>Welcome to your dashboard.</p>
      </div>
      {/* Regmap Modal */}
      {showRegmap && (
        <div style={backdropStyle} onClick={() => setShowRegmap(false)}>
          <div style={formStyle} onClick={(e) => e.stopPropagation()}>
            <button
              style={closeBtnStyle}
              aria-label="Close signup"
              onClick={() => setShowRegmap(false)}
            >
              ×
            </button>

            <h2 style={{ margin: "0 0 18px", fontSize: 22 }}>Map Outlet Now</h2>

            {/* Name */}
            <input
              style={inputStyle}
              placeholder="Name"
              value={signupData.name}
              onChange={(e) =>
                setSignupData({ ...signupData, name: e.target.value })
              }
            />

            {/* Address + load button perfectly inside input */}
            <div style={{ position: "relative", width: "100%" }}>
              <input
                style={{ ...inputStyle, paddingRight: 120, height: 45 }}
                placeholder="Enter Address"
                value={signupData.address}
                onChange={(e) =>
                  setSignupData({ ...signupData, address: e.target.value })
                }
              />

              {/* STEP 4 BUTTON GOES RIGHT HERE */}
              <button
                onClick={() => {
                  // Try to get current GPS location
                  navigator.geolocation.getCurrentPosition(
                    (pos) => {
                      setMapPosition({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                      });
                      setShowMap(true);
                    },
                    () => setShowMap(true) // If denied, still open map
                  );
                }}
                style={{
                  position: "absolute",
                  right: 5,
                  top: 5,
                  height: "35px",
                  width: 110,
                  background: "#007bff",
                  border: "none",
                  borderRadius: 6,
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: 13,
                }}
              >
                Load Map
              </button>
            </div>

            {/* Coordinates Label */}
            <label style={{ marginTop: 15, fontWeight: "600" }}>
              Coordinates
            </label>

            {/* Lat & Long inline */}
            <div style={{ display: "flex", gap: 10, width: "100%" }}>
              <input
                style={{ ...inputStyle, flex: 1 }}
                placeholder="Latitude"
                value={signupData.latitude}
                onChange={(e) =>
                  setSignupData({ ...signupData, latitude: e.target.value })
                }
              />

              <input
                style={{ ...inputStyle, flex: 1 }}
                placeholder="Longitude"
                value={signupData.longitude}
                onChange={(e) =>
                  setSignupData({ ...signupData, longitude: e.target.value })
                }
              />
            </div>

            {/* Image Upload with Preview Frame */}
            <label style={{ marginTop: 15, fontWeight: 600 }}>
              Select Image
            </label>

            <div
              style={{
                width: "100%",
                height: 150,
                border: "1px solid #ccc",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                marginBottom: 10,
              }}
            >
              {signupData.image ? (
                <img
                  src={URL.createObjectURL(signupData.image)}
                  alt="Preview"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <span style={{ color: "#777" }}>No image selected</span>
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setSignupData({ ...signupData, image: e.target.files[0] })
              }
            />

            <button
              style={primaryBtn}
              onClick={() => alert("Outlet Registered on map")}
            >
              Register Now
            </button>
          </div>
        </div>
      )}

      {/*MACDON DECLEARING ANOTHER POP FOR MAP*/}

      {showMap && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: 500,
              background: "#fff",
              borderRadius: 10,
              overflow: "hidden",
              paddingBottom: 15,
            }}
          >
            <h3 style={{ padding: 15, margin: 0 }}>Select Location</h3>

            <div style={{ height: 350 }}>
              <MapContainer
                center={[mapPosition.lat, mapPosition.lng]}
                zoom={15}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>'
                />
                <LayersControl position="topright">
                  <LayersControl.BaseLayer checked name="Street">
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
                    />
                  </LayersControl.BaseLayer>

                  <LayersControl.BaseLayer name="Light Map">
                    <TileLayer
                      url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                      attribution='&copy; <a href="https://carto.com/">CARTO</a>'
                    />
                  </LayersControl.BaseLayer>

                  <LayersControl.BaseLayer name="Dark Map">
                    <TileLayer
                      url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                      attribution='&copy; <a href="https://carto.com/">CARTO</a>'
                    />
                  </LayersControl.BaseLayer>

                  <LayersControl.BaseLayer name="Satellite">
                    <TileLayer
                      url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                      attribution="Tiles &copy; Esri"
                    />
                  </LayersControl.BaseLayer>
                </LayersControl>
                
                <SearchField /> {/* ⭐ SEARCH BAR ADDED HERE */}
                <DraggableMarker
                  position={mapPosition}
                  setPosition={setMapPosition}
                />
              </MapContainer>
            </div>

            <button
              style={{
                width: "90%",
                margin: "10px auto",
                display: "block",
                background: "#007bff",
                color: "#fff",
                padding: "10px 0",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                // Auto-fill lat/long
                setSignupData({
                  ...signupData,
                  latitude: mapPosition.lat,
                  longitude: mapPosition.lng,
                  address: `Lat: ${mapPosition.lat.toFixed(
                    6
                  )}, Lng: ${mapPosition.lng.toFixed(6)}`,
                });

                setShowMap(false);
              }}
            >
              Use This Location
            </button>

            <button
              style={{
                width: "90%",
                margin: "0 auto",
                display: "block",
                background: "#ccc",
                padding: "10px 0",
                borderRadius: 6,
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => setShowMap(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
